<template>
  <div style="background:#fff; border-radius: 8px; box-shadow: 0 4px 25px rgba(0,0,0,0.06); padding: 20px 22px; display:flex; align-items:center; gap:16px;">
    <div :style="{ width: '44px', height: '44px', borderRadius: '10px', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }">
      <vs-icon :icon="iconeVuesax" :color="cor" size="20px"></vs-icon>
    </div>
    <div>
      <div :style="{ fontSize: '24px', fontWeight: 700, color: cor, lineHeight: 1 }">{{ valor }}</div>
      <div style="font-size: 12px; color:#8b8b8b; font-weight:600; text-transform:uppercase; letter-spacing:.03em; margin-top:4px;">{{ label }}</div>
    </div>
  </div>
</template>
<script>
// Cartao de resumo do topo da conferencia diaria (issue #312). Fica junto
// da tela por enquanto - vira /src/components/default so se um segundo
// consumidor de verdade aparecer.
export default {
  name: "ResumoCard",
  props: {
    label: { type: String, required: true },
    valor: { type: Number, default: 0 },
    cor: { type: String, required: true },
    bg: { type: String, required: true },
    icone: { type: String, required: true } // 'total' | 'check' | 'alerta' | 'relogio'
  },
  computed: {
    iconeVuesax() {
      return { total: "description", check: "check_circle", alerta: "error_outline", relogio: "schedule" }[this.icone];
    }
  }
};
</script>
